import React from 'react';
import Modal from 'react-bootstrap/Modal';

interface IModalMetabaseProps {
  visible: boolean;
  close: (orderId?: number) => void;
  title: string;
  source: string;
}

const ModalMetabase: React.FC<IModalMetabaseProps> = ({
  visible,
  close,
  title,
  source
}) => {

  if (!visible) return null;

  return (
    <Modal
      show={visible}
      onHide={() => clickCloseModal()}
      backdrop="static"
      keyboard={false}
      dialogClassName='modal-full-screen'
    >
      <Modal.Header closeButton style={{ height: '50px' }}>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body id='modalMetabaseBody' style={{height:'85vh',maxHeight:'85vh',overflowY:'auto'}}>
        <iframe
          src={source}
          width="100%"
          height="99%"
        ></iframe>
      </Modal.Body>
    </Modal>
  );

  function clickCloseModal() {
    close();
  }
}

export { ModalMetabase };